import type { ScriptableContext } from 'chart.js'

/**
 * Creates a gradient to fill the area between connected line charts
 * @param {ScriptableContext<'line'>} ctx - The chart context
 * @param {string} color - The color for the gradient, in hex format
 * @returns {CanvasGradient} - The created gradient
 */
export function createGradient(
  ctx: ScriptableContext<'line'>,
  color: string,
): CanvasGradient {
  const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, ctx.chart.height)
  gradient.addColorStop(0, `${color}00`) // Fully transparent at the top
  gradient.addColorStop(1, `${color}33`) // 20% opacity at the bottom
  return gradient
}
